import { render, staticRenderFns } from "./ArtigosSeoPanel.vue?vue&type=template&id=5d18737e&scoped=true&"
import script from "./ArtigosSeoPanel.vue?vue&type=script&lang=js&"
export * from "./ArtigosSeoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosSeoPanel.vue?vue&type=style&index=0&id=5d18737e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18737e",
  null
  
)

export default component.exports